import React from 'react';
import { Form, FormGroup, FormControl, Button, Modal, Container, Row, Col } from 'react-bootstrap';
import { CustomDatePicker } from '../../_components';
import config from '../../../config';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { Navigate } from 'react-router';
import { isAdmin } from '../../utils/roleConstants';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';


class DataManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timestamp: new Date(),
            product: [],
            machine: {},
            modalShow: false,
            newMode: false,
            newModalShow: false,
            body: [],
            actOutput: 0,
            oee: 0,
            productivity: 0,
            executionNumber: 0,
            jobOrder: 0,
            actOutput: 0,
            planOutput: 0,
            engReject: 0,
            prdReject: 0,
            machineDown: 0,
            machineEquipment: 0,
            mouldBreakdown: 0,
            jigFixture: 0,
            engineeringBuild: 0,
            machineSupportDoc: 0,
            manpower: 0,
            facility: 0,
            materialDelay: 0,
            unplanBriefing: 0,
            isLoading: false
        };
        this.columns = [
            {
                name: 'Timestamp',
                selector: row => row.timestamp,
            },
            {
                name: 'Part No',
                selector: row => row.executionNo,
                sortable: true,
            },
            {
                name: 'Job No',
                selector: row => row.jobOrder,
                sortable: true,
            },
            {
                name: 'Employee ID',
                selector: row => row.employeeID,
                sortable: true,
            },
            {
                name: 'Remarks',
                selector: row => row.remark,
                sortable: true,
            },
            {
                name: 'Action',
                cell: (row, rowIndex) => (
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'nowrap' }}>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            onClick={() => this.onClickProductSelected(row.id, row, rowIndex)}
                        >
                            Edit
                        </button>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            onClick={() =>
                                window.confirm("Are you sure you want to delete this data?") &&
                                this.onDeleteProduct(row.id, row, rowIndex)
                            }
                        >
                            Delete
                        </button>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                width: '180px',
            }]
    }

    componentWillMount() {

        this.setState({
            machines: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            fetch(`${config.apiUrl}/getAllMachines?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(machine => {
                    // login successful if there's a user in the response
                    if (machine) {
                        this.setState({ machines: machine });

                    }

                    return machine;
                });
        }

    }

    buildHtmlTable() {
        this.setState({ isLoading: true });
        const { tableStyle, tableHeader } = this.state;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ machine: this.state.selectedMachine, date: this.state.selectedDate })
        };

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getMachineByDate?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(body => {
                    // login successful if there's a user in the response
                    let array = [];
                    const products = [];

                    body.map((machine) => {
                        array.push({
                            ...machine,
                            timestamp: (new Date(machine.Timestamp)).toLocaleTimeString(),
                            executionNo: machine.executionNo,
                            employeeID: machine.employeeID,
                            jobOrder: machine.jobOrder,
                            remark: machine.remark
                        })
                    });

                    this.setState({ products: array, body: body, isLoading: false });
                })
                .catch(error => {
                    console.error('Error fetching machine data:', error);
                    this.setState({ products: [], body: [], isLoading: false });
                });

        this.setState({ isLoading: false });
        return Promise.resolve();
    }


    onClickProductSelected(cell, row, rowIndex) {
        this.setState({ modalShow: true });
        this.setState({ newMode: false });
        this.setState({ timestamp: row.Timestamp });
        this.setState({ executionNumber: row.executionNo });
        this.setState({ cycleTime: row.cycleTime });
        this.setState({ jobOrder: row.jobOrder });
        this.setState({ employeeID: row.employeeID });
        this.setState({ actOutput: row.actOutput });
        this.setState({ planOutput: row.planOutput });
        this.setState({ engReject: row.engReject });
        this.setState({ prdReject: row.prdReject });
        this.setState({ machineDown: row.machineDown });
        this.setState({ machineEquipment: row.machineEquipment });
        this.setState({ mouldBreakdown: row.mouldBreakdown });
        this.setState({ jigFixture: row.jigFixture });
        this.setState({ engineeringBuild: row.engineeringBuild });
        this.setState({ machineSupportDoc: row.machineSupportDoc });
        this.setState({ manpower: row.manpower });
        this.setState({ facility: row.facility });
        this.setState({ materialDelay: row.materialDelay });
        this.setState({ unplanBriefing: row.unplanBriefing });
        this.setState({ oee: row.oee });
        this.setState({ productivity: row.productivity });
        this.setState({ remark: row.remark });
        this.setState({ id: row.id });
    }

    onDeleteProduct(cell, row, rowIndex) {
        fetch(`${config.apiUrl}/delete`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                id: row.id,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    this.buildHtmlTable();
                }
            });
    }



    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!isAdmin(user)) {
            return <Navigate to='/' />
        }
        let { modalShow, newMode, products, timestamp, cycleTime, oee, productivity, executionNumber, jobOrder, employeeID, actOutput, planOutput, engReject, prdReject, machineDown, machineEquipment, mouldBreakdown, jigFixture, engineeringBuild, machineSupportDoc, manpower, facility, materialDelay, unplanBriefing, remark } = this.state;
        let handleClose = () => this.setState({ modalShow: false });
        let handleSave = () => {
            window.confirm("Are you sure you update this data?") && fetch(`${config.apiUrl}/update`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    executionNo: this.state.executionNumber,
                    employeeID: this.state.employeeID,
                    jobOrder: this.state.jobOrder,
                    cycleTime: this.state.cycleTime,
                    planOutput: this.state.planOutput,
                    actOutput: this.state.actOutput,
                    engReject: this.state.engReject,
                    prdReject: this.state.prdReject,
                    machineDown: this.state.machineDown,
                    machineEquipment: this.state.machineEquipment,
                    machineSupportDoc: this.state.machineSupportDoc,
                    mouldBreakdown: this.state.mouldBreakdown,
                    engineeringBuild: this.state.engineeringBuild,
                    jigFixture: this.state.jigFixture,
                    manpower: this.state.manpower,
                    materialDelay: this.state.materialDelay,
                    facility: this.state.facility,
                    unplanBriefing: this.state.unplanBriefing,
                    oee: this.state.oee,
                    productivity: this.state.productivity,
                    remark: this.state.remark,
                    id: this.state.id,
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        window.alert('Update Successfully.');

                        this.setState({ modalShow: false });
                        this.buildHtmlTable();
                    }
                });
        }

        let handleCreate = () => {
            fetch(`${config.apiUrl}/upload2`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    machine: this.state.selectedMachine,
                    executionNo: this.state.executionNumber,
                    employeeID: this.state.employeeID,
                    jobOrder: this.state.jobOrder,
                    cycleTime: this.state.cycleTime,
                    planOutput: this.state.planOutput,
                    actOutput: this.state.actOutput,
                    engReject: this.state.engReject,
                    prdReject: this.state.prdReject,
                    machineDown: this.state.machineDown,
                    machineEquipment: this.state.machineEquipment,
                    machineSupportDoc: this.state.machineSupportDoc,
                    mouldBreakdown: this.state.mouldBreakdown,
                    engineeringBuild: this.state.engineeringBuild,
                    jigFixture: this.state.jigFixture,
                    manpower: this.state.manpower,
                    materialDelay: this.state.materialDelay,
                    facility: this.state.facility,
                    unplanBriefing: this.state.unplanBriefing,
                    oee: this.state.oee,
                    productivity: this.state.productivity,
                    remark: this.state.remark,
                    category: this.state.selectedCategory,
                    company: JSON.parse(localStorage.getItem('user')).accountId,
                    created_by: JSON.parse(localStorage.getItem('user')).id,
                    Timestamp: new Date(this.state.selectedDate + ' ' + moment(this.state.timestamp).format('HH:mm'))
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.setState({ modalShow: false });
                        this.setState({ newMode: false });
                        window.alert('New data created successfully.');
                        this.buildHtmlTable();
                    }
                });
        }

        let calculateOEE = () => {
            setTimeout(() => {
                this.setState({
                    oee: this.state.actOutput / (this.state.actOutput + this.state.engReject + this.state.prdReject + this.state.machineDown + this.state.machineEquipment
                        + this.state.mouldBreakdown + this.state.jigFixture + this.state.engineeringBuild + this.state.machineSupportDoc
                        + this.state.manpower + this.state.facility + this.state.materialDelay + this.state.unplanBriefing) * 100
                });
                this.setState({ productivity: ((this.state.actOutput + this.state.engReject + this.state.prdReject) / this.state.planOutput) * 100 });

            }, 500);

        }

        let isTally = () => {
            return planOutput == (actOutput + engReject + prdReject + machineDown + machineEquipment
                + mouldBreakdown + jigFixture + engineeringBuild + machineSupportDoc
                + manpower + facility + materialDelay + unplanBriefing);
        }

        return (
            <div class="container">
                <div style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                    <Form inline>
                        <FormGroup controlId="formInlineName">
                            <Form.Label>Select a machine:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedMachineId} onChange={(e) => {
                                    if (e.target.value != 'select') {
                                        this.setState({
                                            selectedMachine: e.target.value.split(';')[0], selectedCategory: e.target.value.split(';')[1]
                                        })
                                    } else {
                                        delete this.state.selectedMachine;
                                    }
                                }}>
                                <option value="select">select</option>
                                {
                                    this.state.machines.map((machine) => {
                                        return <option key={machine.id} value={machine.machine + ';' + machine.category}>{machine.machine}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{' '}
                        <CustomDatePicker
                            label="Date"
                            controlId="formInlineDate"
                            value={this.state.selectedDate}
                            onChange={(value) => this.setState({ selectedDate: value })}
                        />{' '}
                        <Button
                            bsStyle="primary"
                            // disabled={isLoading}
                            // onClick={!isLoading ? this.handleClick : null}
                            onClick={e => this.buildHtmlTable()}>Show</Button>
                        {this.state.selectedMachine && this.state.selectedDate && (<Button
                            style={{ right: 0, position: 'absolute' }}
                            bsStyle="danger"
                            visi
                            onClick={e => { 
                                this.setState({ 
                                    modalShow: true, 
                                    newMode: true,
                                    timestamp: new Date(),
                                    executionNumber: '',
                                    cycleTime: '',
                                    jobOrder: '',
                                    employeeID: '',
                                    actOutput: 0,
                                    planOutput: 0,
                                    engReject: 0,
                                    prdReject: 0,
                                    machineDown: 0,
                                    machineEquipment: 0,
                                    mouldBreakdown: 0,
                                    jigFixture: 0,
                                    engineeringBuild: 0,
                                    machineSupportDoc: 0,
                                    manpower: 0,
                                    facility: 0,
                                    materialDelay: 0,
                                    unplanBriefing: 0,
                                    oee: 0,
                                    productivity: 0,
                                    remark: ''
                                }); 
                            }}>New</Button>)}

                    </Form>
                </div>
                <DataTable
                    columns={this.columns}
                    data={products}
                    progressPending={this.state.isLoading}
                    progressComponent={<DatacoLoadingIndicator loading={this.state.isLoading} size="compact" label="Loading machine data" />}
                    pagination
                    highlightOnHover
                />
                <Modal size="lg" show={modalShow} onHide={handleClose}
                    aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w">
                    <Modal.Header closeButton>
                        {newMode ? (<Modal.Title>New</Modal.Title>) : (<Modal.Title>Edit</Modal.Title>)}
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <Form>
                                <FormGroup className="row" as={Row} controlId="formInlineTimestamp" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Timestamp:</Form.Label></Col>
                                    <Col sm={9}> {newMode ?
                                        (<DatePicker
                                            selected={timestamp && timestamp instanceof Date && !isNaN(timestamp) ? timestamp : new Date()}
                                            onChange={(date) => this.setState({ timestamp: date })}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={30}           // equivalent to minuteStep="30"
                                            timeCaption="Time"
                                            dateFormat="h:mm aa"         // 12-hour format
                                            className="xxx"              // replace "class" with "className"
                                            readOnly                      // equivalent to inputReadOnly
                                        />) :
                                        (<FormControl plaintext readOnly value={timestamp ? new Date(timestamp).toLocaleTimeString() : ''} />)}
                                    </Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineCycletime" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Cycle Time</Form.Label></Col>
                                    <Col sm={9}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ cycleTime: Number(ev.target.value) || 0 }) }} value={cycleTime} />
                                    </Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineExecutionNo" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Part No</Form.Label></Col>
                                    <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ executionNumber: ev.target.value }) }} value={executionNumber} />
                                    </Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineJobrOrder" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Job No</Form.Label></Col>
                                    <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ jobOrder: ev.target.value }) }} value={jobOrder} />
                                    </Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlineEmployeeID" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Employee ID</Form.Label></Col>
                                    <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ employeeID: ev.target.value }) }} value={employeeID} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Plan Output</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ planOutput: Number(ev.target.value) }); calculateOEE(); }} value={planOutput} /></Col>
                                    <Col sm={3}><Form.Label>Actual Output</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ actOutput: Number(ev.target.value) }); calculateOEE(); }} value={actOutput} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Engineering Reject</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ engReject: Number(ev.target.value) }); calculateOEE(); }} value={engReject} /></Col>
                                    <Col sm={3}><Form.Label>Production Reject</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ prdReject: Number(ev.target.value) }); calculateOEE(); }} value={prdReject} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Machine Breakdown</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ machineDown: Number(ev.target.value) }); calculateOEE(); }} value={machineDown} /></Col>
                                    <Col sm={3}><Form.Label>Tooling Breakdown</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ mouldBreakdown: Number(ev.target.value) }); calculateOEE(); }} value={mouldBreakdown} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Jig&Fixture</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ jigFixture: Number(ev.target.value) }); calculateOEE(); }} value={jigFixture} /></Col>
                                    <Col sm={3}><Form.Label>Engineering build</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ engineeringBuild: Number(ev.target.value) }); calculateOEE(); }} value={engineeringBuild} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Change-over</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ machineSupportDoc: Number(ev.target.value) }); calculateOEE(); }} value={machineSupportDoc} /></Col>
                                    <Col sm={3}><Form.Label>Machine Equipment</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ machineEquipment: Number(ev.target.value) }); calculateOEE(); }} value={machineEquipment} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>OEE%</Form.Label></Col>
                                    <Col sm={3}><FormControl plaintext readOnly value={oee} /></Col>
                                    <Col sm={3}><Form.Label>Productivity%</Form.Label></Col>
                                    <Col sm={3}><FormControl plaintext readOnly value={productivity} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Manpower</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ manpower: Number(ev.target.value) }); calculateOEE(); }} value={manpower} /></Col>
                                    <Col sm={3}><Form.Label>Facility</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ facility: Number(ev.target.value) }); calculateOEE(); }} value={facility} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Material Delay</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ materialDelay: Number(ev.target.value) }); calculateOEE(); }} value={materialDelay} /></Col>
                                    <Col sm={3}><Form.Label>Unplan Meeting</Form.Label></Col>
                                    <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ unplanBriefing: Number(ev.target.value) }); calculateOEE(); }} value={unplanBriefing} /></Col>
                                </FormGroup>
                                <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                    <Col sm={3}><Form.Label>Remark</Form.Label></Col>
                                    <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ remark: ev.target.value }) }} value={remark} /></Col>
                                </FormGroup>
                            </Form>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        {(executionNumber != 0 && planOutput != 0 && actOutput != 0 && isTally() && newMode) && (<Button variant="primary" onClick={handleCreate}>
                            Create
                        </Button>)}

                        {!newMode && (<Button variant="primary" onClick={handleSave}>
                            Save Changes
                        </Button>)}
                    </Modal.Footer>
                </Modal>
            </div>

        );
    }
}

export { DataManagement };
